import React from "react";

//id/name đều có tiền tố "nv" vì các tab cùng nằm trong DOM, trùng id thì label bấm nhầm sang tab khác
export const CauHinhHuyDongVon = ({
  data,
  setField,
  CustomCheckbox,
  CustomRadio,
}) => {
  const isAnyKyDongLaiEnabled =
    data.KyDongLaiNgayEnabled ||
    data.KyDongLaiThangEnabled ||
    data.KyDongLaiThangDinhKyEnabled;

  const handleSelectAll = (e) => {
    setField("KyDongLaiNgayEnabled", e.target.checked);
    setField("KyDongLaiThangEnabled", e.target.checked);
    setField("KyDongLaiThangDinhKyEnabled", e.target.checked);
  };

  const renderCheckbox = (id, field, label, className) => (
    <CustomCheckbox
      id={id}
      name={`nv${field}`}
      checked={!!data[field]}
      onChange={(e) => setField(field, e.target.checked)}
      label={label}
      className={className}
    />
  );

  const renderRadio = (id, field, value, label, className) => (
    <CustomRadio
      id={id}
      name={`nv${field}`}
      value={value}
      checked={data[field] === value}
      onChange={() => setField(field, value)}
      label={label}
      className={className}
    />
  );

  const renderLaiSuat = (title, ky, macDinhField, giaTriField) => (
    <div className="interest-rate-group">
      <h4 className="interest-rate-title">Kỳ đóng lãi: {title}</h4>
      <div className="d-flex config-container">
        <div className="config-card flex-grow-1">
          <div className="config-card-header">Danh sách</div>
          <div className="config-card-body">
            {renderCheckbox(
              `nvChkTrieuNgay${ky}`,
              `LaiTrieuNgay_${ky}Enabled`,
              "Lãi/Triệu/Ngày"
            )}
            {renderCheckbox(`nvChkNgay${ky}`, `LaiNgay_${ky}Enabled`, "Lãi/ngày")}
            {renderCheckbox(
              `nvChkThang${ky}`,
              `LaiThang_${ky}Enabled`,
              "Lãi%/Tháng"
            )}
          </div>
        </div>
        <div className="config-card flex-grow-1">
          <div className="config-card-header">Nhãn được chọn (Mặc định)</div>
          <div className="config-card-body">
            {data[`LaiTrieuNgay_${ky}Enabled`] &&
              renderRadio(`nvRdTrieuNgay${ky}`, macDinhField, 1, "Lãi/Triệu/Ngày")}
            {data[`LaiNgay_${ky}Enabled`] &&
              renderRadio(`nvRdNgay${ky}`, macDinhField, 2, "Lãi/ngày")}
            {data[`LaiThang_${ky}Enabled`] &&
              renderRadio(`nvRdThang${ky}`, macDinhField, 3, "Lãi%/Tháng")}
            <input
              type="text"
              className="form-control input-sm mt-1"
              value={data[giaTriField] || ""}
              onChange={(e) => setField(giaTriField, e.target.value)}
              placeholder="Giá trị mặc định"
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="form-body custom-form-layout">
      <div className="form-group row">
        <label className="col-md-2 label-control">
          Cách tính số ngày trả lãi
        </label>
        <div className="col-md-10 d-flex align-items-center">
          {renderRadio(
            "nvNgayTraTruNgayVay",
            "CachTinhLai",
            1,
            "Ngày trả - Ngày vay",
            "mb-0 mr-3"
          )}
          {renderRadio(
            "nvNgayTraTruNgayVayCong1",
            "CachTinhLai",
            2,
            "(Ngày trả - Ngày vay) + 1",
            "mb-0"
          )}
        </div>
      </div>

      <div className="form-group row">
        <label className="col-md-2 label-control">
          Cách tính ngày lãi vay thêm
        </label>
        <div className="col-md-10 d-flex align-items-center">
          {renderRadio(
            "nvNgayVayThem",
            "NgayVayThemOption",
            0,
            "Ngày vay thêm",
            "mb-0 mr-3"
          )}
          {renderRadio(
            "nvNgayVayThemCong1",
            "NgayVayThemOption",
            1,
            "Ngày vay thêm + 1",
            "mb-0"
          )}
        </div>
      </div>

      <div className="form-group row form-date-mm ky-dong-lai-section">
        <label className="col-md-2 label-control">Kỳ đóng lãi</label>
        <div className="col-md-10">
          <CustomCheckbox
            id="nvChonTatCaKyDongLai"
            checked={
              !!(
                data.KyDongLaiNgayEnabled &&
                data.KyDongLaiThangEnabled &&
                data.KyDongLaiThangDinhKyEnabled
              )
            }
            onChange={handleSelectAll}
            label="Chọn tất cả"
          />
          <div
            className="d-flex flex-column flex-md-row config-container"
            style={{ marginTop: "1rem" }}
          >
            <div className="config-card flex-grow-1">
              <div className="config-card-header">DANH SÁCH</div>
              <div className="config-card-body">
                {renderCheckbox("nvCheckNgay", "KyDongLaiNgayEnabled", "Ngày")}
                {renderCheckbox("nvCheckThang", "KyDongLaiThangEnabled", "Tháng")}
                {renderCheckbox(
                  "nvCheckThangDinhKy",
                  "KyDongLaiThangDinhKyEnabled",
                  "Tháng định kỳ"
                )}
              </div>
            </div>
            <div className="config-card flex-grow-1">
              <div className="config-card-header">NHÃN ĐƯỢC CHỌN</div>
              <div className="config-card-body">
                {data.KyDongLaiNgayEnabled &&
                  renderRadio("nvRadioNgay", "KyDongLaiMacDinh", 1, "Ngày")}
                {data.KyDongLaiThangEnabled &&
                  renderRadio("nvRadioThang", "KyDongLaiMacDinh", 2, "Tháng")}
                {data.KyDongLaiThangDinhKyEnabled &&
                  renderRadio(
                    "nvRadioThangDinhKy",
                    "KyDongLaiMacDinh",
                    3,
                    "Tháng định kỳ"
                  )}
                <div className="mt-1">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Giá trị mặc định"
                    value={data.KyDongLai || ""}
                    onChange={(e) => setField("KyDongLai", e.target.value)}
                    disabled={!isAnyKyDongLaiEnabled}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="form-group row form-date-mm lai-suat-section">
        <label className="col-md-2 label-control">Lãi suất</label>
        <div className="col-md-10">
          {data.KyDongLaiNgayEnabled &&
            renderLaiSuat("Ngày", "Ngay", "LaiSuatNgayMacDinh", "LaiSuatNgay")}
          {data.KyDongLaiThangEnabled &&
            renderLaiSuat(
              "Tháng",
              "Thang",
              "LaiSuatThangMacDinh",
              "LaiSuatThang"
            )}
        </div>
      </div>

      <div className="form-group row">
        <label className="col-md-2 label-control">Kiểu thanh toán</label>
        <div className="col-md-10">
          {renderCheckbox(
            "nvAllBeforeAfter",
            "AllBeforeAfter",
            "Hiển thị tất cả (Chọn mặc định)"
          )}
          <div className="d-flex align-items-center mt-2">
            {renderRadio("nvTraTruoc", "BeforeAfter", 2, "Trước", "mb-0 mr-3")}
            {renderRadio("nvTraSau", "BeforeAfter", 1, "Sau", "mb-0")}
          </div>
        </div>
      </div>
    </div>
  );
};
